import { Box, Button, FileButton, Image, LoadingOverlay } from "@mantine/core";
import { IconPhotoPlus } from "@tabler/icons-react";
import React from "react";
import { MediaApi } from "../../apis";
import { Message } from "../../utils/message";
import classes from "./image-upload.module.css";

export type IFile = {
  uploading: boolean;
  url?: string;
  file: Blob | null;
};

type Props = {
  value?: string | undefined | null;
  error?: string;
  onChange?: (file: IFile) => void;
  disabled?: boolean;
};

export function ImageUpload({ onChange, error, value, disabled }: Props) {
  const [file, setFile] = React.useState<IFile>();
  const resetRef = React.useRef<() => void>(null);

  const onFileUpload = (blob: Blob | null) => {
    if (!blob) return;

    (async () => {
      try {
        const form = new FormData();
        form.append("file", blob);

        const res = await MediaApi.uploadImage(form);

        if (onChange)
          onChange({
            file: blob,
            url: res.url,
            uploading: false,
          });

        setFile({
          file: blob,
          url: res.url,
          uploading: false,
        });
      } catch (err: any) {
        Message.error(err?.message);
      }
    })();

    setFile({
      file: blob,
      uploading: true,
    });
  };

  React.useEffect(() => {
    value &&
      setFile({
        file: null,
        url: value,
        uploading: false,
      });
  }, [value]);

  return (
    <Box className={classes.multiImageUpload}>
      <FileButton resetRef={resetRef} onChange={onFileUpload} accept="image/png,image/jpeg" disabled={disabled}>
        {(props) =>
          file ? (
            <Box className={classes.imageBox} {...props}>
              <Image className={classes.image} w={80} h={80} src={file.file ? URL.createObjectURL(file.file) : file.url} alt="" />
              <LoadingOverlay visible={file.uploading} opacity={0.3} loaderProps={{ size: "sm" }} />
            </Box>
          ) : (
            <Button variant="light" className={[classes.uploadButton, error && classes.error].filter(Boolean).join(" ")} {...props}>
              <IconPhotoPlus size={20} />
            </Button>
          )
        }
      </FileButton>
    </Box>
  );
}
